<template>
  <div style="display: none;"></div>
</template>
<script>
import BaseSendRequestMixin from "../../components/mixins/BaseSendRequestMixin.vue";
import BaseMessagingMixin from "../../components/mixins/BaseMessagingMixin.vue";

export default {
  name: 'webPushNotification',
  props: [
    'user',
  ],
  mixins: [
    BaseSendRequestMixin,
    BaseMessagingMixin
  ],
  async mounted() {
    if (!this.user) {
      return;
    }

    if (!('serviceWorker' in navigator)) return;

    const isSubscribed = await this.checkSubscription();
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      if (isSubscribed) {
        await this.deleteSubscription();
      }

      return;
    }

    if (isSubscribed) {
      return;
    }

    await this.registerAndSubscribe();
  },

  methods: {
    async deleteSubscription() {
      await this.sendRequest('/cabinet/client/webpush/deleteSubscription', 'post', {endpoint: localStorage.getItem('endpoint')});
      localStorage.removeItem('endpoint')
    },
    async checkSubscription() {
      const response = await this.sendRequest('/cabinet/client/webpush/checkSubscription', 'post', {endpoint: localStorage.getItem('endpoint')});
      return response.isSubscribed;
    },

    async registerAndSubscribe() {
      try {
        const publicKeyData = await this.sendRequest('/cabinet/client/webpush/getPublicKey');

        const reg = await navigator.serviceWorker.register('/js/service-worker.js', {
          scope: '/js/'
        });

        const sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: this.urlBase64ToUint8Array(publicKeyData.public_key)
        });

        const subscriptionData = sub.toJSON();

        localStorage.setItem('endpoint', subscriptionData.endpoint);

        let formData = new FormData();
        formData.append('endpoint', subscriptionData.endpoint);
        formData.append('auth', subscriptionData.keys.auth);
        formData.append('p256dh', subscriptionData.keys.p256dh);
        await this.sendRequest('/cabinet/client/webpush/subscribe', 'post', formData);
        console.log('webPush: on')
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          // await this.alertMessage('Пожалуйста, разрешите уведомления в настройках браузера, чтобы получать обновления.');
        } else {
          await this.alertMessage('Произошла ошибка при подписке на уведомления.', 'warning');
        }
      }
    },
    urlBase64ToUint8Array(base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4);
      const base64 = (base64String + padding)
          .replace(/-/g, '+')
          .replace(/_/g, '/');
      const rawData = atob(base64);
      return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
    }
  }
}
</script>